/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { ActivatedRoute } from '@angular/router';
import {
  REPORT_CONFIG,
  ReportConfig
} from '../components/new-navigation/rankings/REPORT_CONFIG';
import { HttpClient } from '@angular/common/http';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { MainFilterItem } from '../components/new-navigation/rankings/models/mainFilterItem';
import { CapitalizePipe } from '../pipes/capitalize.pipe';
import { DEFAULT_COUNTRY_PER_REGION_MAPPING } from 'app/components/new-navigation/rankings/REPORT_CONFIG_CONST';
import { toDeviceSlug } from 'app/constants/PLATFORM_SLUGS';
import { User } from 'app/models/User';

@Injectable({
  providedIn: 'root'
})
export class RankingsService extends BaseApiService {
  rankingsDataCache: any;
  route: ActivatedRoute;
  capitalizePipe: CapitalizePipe = new CapitalizePipe();

  constructor(
    private http: HttpClient,
    private titleService: Title,
    private metaService: Meta,
    private userServce: User
  ) {
    super();
    this.rankingsDataCache = {};
  }

  setPageDocumentMeta(reportConfigKey: string, propMap: any): void {
    const foundConfig = REPORT_CONFIG.filter(
      config => config.key === reportConfigKey
    );
    if (foundConfig && foundConfig[0]) {
      this.titleService.setTitle(
        this.synthesizeTextByTypeAndFilters(foundConfig[0].pageTitle, propMap)
      );
      const tag: MetaDefinition = {
        name: 'description',
        content: this.synthesizeTextByTypeAndFilters(
          foundConfig[0].pageMeta,
          propMap
        )
      };
      this.metaService.updateTag(tag);
    }
  }

  synthesizeTextByTypeAndFilters(text: string, propMap) {
    const keys = text.match(/{([^}]+)}/gi) || [];
    keys.forEach(key => {
      if (key === '{type}') {
        text = text.replace(key, this.getTypeLabel(propMap['type'] || ''));
      } else if (key === '{platformName}') {
        text = text.replace(
          key,
          this.getPlatformLabel(propMap['platformName']) || ''
        );
      } else if (key === '{countryCode}') {
        text = text.replace(
          key,
          (propMap['countryCode'] || '').replace(/(<([^>]+)>)/gi, '')
        );
      } else if (key === '{date}') {
        text = text.replace(key, propMap['date'] || '');
      }
    });
    return text;
  }

  getPlatformLabel(platform: string) {
    let label = '';
    switch (platform) {
      case 'roku':
        label = 'Roku Store';
        break;
      case 'firetv':
        label = 'Fire TV Store';
        break;
      case 'samsung':
        label = 'Samsung Store';
        break;
      case 'tvos':
        label = 'tvOS Store';
        break;
      case 'lgtv':
        label = 'LG TV';
        break;
      case 'android':
        label = 'Google Play';
        break;
      case 'ios':
        label = 'App Store';
        break;
      default:
        label = platform;
        break;
    }
    return label;
  }

  getTypeLabel(type: string) {
    let label = '';
    switch (type) {
      case 'ctv':
        label = 'Connected TV';
        break;
      case 'domain':
        label = 'Websites';
        break;
      case 'app':
        label = 'Mobile Apps';
        break;
      default:
        label = 'Unknown Type';
        break;
    }
    return label;
  }

  getRankingsFacets(
    facets: Array<string>,
    reportId: string,
    group: string,
    additionalQueryParams?: string
  ) {
    return new Promise(resolve => {
      const facetsString = facets.join('&');
      let url = `${this.getRatingsBaseUrl(
        '2020'
      )}/getRankingsFacets?reportId=${reportId}&group=${group}&${facetsString}`;

      if (additionalQueryParams && additionalQueryParams.length > 0) {
        url += `&${additionalQueryParams}`;
      }

      if (this.rankingsDataCache[url]) {
        setTimeout(() => {
          const cacheData = this.rankingsDataCache[url];
          resolve(JSON.parse(JSON.stringify(cacheData)));
        }, 300);
      } else {
        this.http.get(url).subscribe(res => {
          this.storeCache(res, this.rankingsDataCache, url);
          resolve(res);
        });
      }
    });
  }

  getRankingsData(
    reportId: string,
    group: string,
    start,
    limit,
    additionalQueryString: string
  ) {
    return new Promise(resolve => {
      let url =
        `${this.getRatingsBaseUrl(
          '2020'
        )}/getRankings?reportId=${reportId}&group=${group}&` +
        `${additionalQueryString}&start=${start}&limit=${limit}`;

      if (this.rankingsDataCache[url]) {
        setTimeout(() => {
          const cacheData = this.rankingsDataCache[url];
          resolve(JSON.parse(JSON.stringify(cacheData)));
        }, 300);
      } else {
        this.http.get(url).subscribe(res => {
          this.storeCache(res, this.rankingsDataCache, url);
          resolve(res);
        });
      }
    });
  }

  getExportUri(reportId: string, whereClause: string) {
    return new Promise(resolve => {
      this.http
        .get(
          `${this.getReportBaseUrl()}/getExportUri?reportId=${reportId}&q=${whereClause}&limit=1000&callback=JSONP_CALLBACK`
        )
        .subscribe(res => {
          resolve(res['_body']);
        });
    });
  }

  // UI Services
  loadMonthOptions(
    reportConfig: ReportConfig,
    currentConfig: ReportConfig,
    mainFilterItems: Array<MainFilterItem>,
    monthFilterItem: MainFilterItem,
    selectedGroup: string,
    isSummary,
    route?: ActivatedRoute
  ) {
    return new Promise(resolve => {
      const facets = [];
      // `category=GLOBAL&countryCode=AE&platformName=android
      // facets.push('facet=category');
      // facets.push('facet=countryCode');
      // facets.push('facet=platformName');
      facets.push('facet=date');
      let additionalQueryParams = '';
      const queryParams = [];
      if (monthFilterItem && monthFilterItem.dependencies) {
        const foundDependencyList = monthFilterItem.dependencies.filter(
          dependency => dependency.group === selectedGroup
        );
        if (foundDependencyList && foundDependencyList.length > 0) {
          foundDependencyList.forEach(foundDependency => {
            const foundDependencyFilter = mainFilterItems.filter(
              filter => foundDependency.key === filter.key
            );
            if (foundDependencyFilter && foundDependencyFilter[0]) {
              const value = foundDependencyFilter[0].selected.value;
              queryParams.push(`${foundDependency.key}=${value}`);
            }
          });
        }
      }
      if (queryParams.length > 0) {
        additionalQueryParams = queryParams.join('&');
      }
      const reportId =
        isSummary && reportConfig
          ? reportConfig.reportId
          : currentConfig.reportId;
      void this.getRankingsFacets(
        facets,
        reportId,
        selectedGroup,
        additionalQueryParams
      ).then(response => {
        const items = response['facets'][monthFilterItem.key];
        if (items && items.length > 0) {
          items.forEach(item => {
            const keys = Object.keys(item);
            const option: any = {};
            option.label = this.getMonthOptionLabel(reportId, keys[0]);
            option.value = keys[0];
            option.disabled = true;

            monthFilterItem.options.push(option);
          });
          monthFilterItem.options = monthFilterItem.options.sort(
            (option1, option2) => option2.value.localeCompare(option1.value)
          );

          monthFilterItem.options[0].disabled = false;
          monthFilterItem.selected = monthFilterItem.options[0];

          // Load Facets based on dependency key and group
          const promises = [];
          mainFilterItems
            .filter(
              item => !item.groups || item.groups.indexOf(selectedGroup) >= 0
            )
            .forEach(mainFilterItem => {
              if (
                mainFilterItem &&
                mainFilterItem.dependencies &&
                mainFilterItem.dependencies.length > 0
              ) {
                const foundDependency = mainFilterItem.dependencies.some(
                  dependency =>
                    dependency.key === monthFilterItem.key &&
                    (!dependency.group || dependency.group === selectedGroup)
                );
                if (foundDependency) {
                  promises.push(
                    this.loadOptions(
                      mainFilterItem,
                      reportConfig,
                      currentConfig,
                      selectedGroup,
                      isSummary,
                      route
                    )
                  );
                }
              }
            });
          if (promises.length > 0) {
            void Promise.all(promises).then(() => {
              resolve(true);
            });
          } else {
            resolve(true);
          }
        }
      });
    });
  }

  loadOptions(
    mainFilterItem: MainFilterItem,
    reportConfig: ReportConfig,
    currentConfig: ReportConfig,
    selectedGroup: string,
    isSummary: boolean,
    route?: ActivatedRoute
  ) {
    return new Promise(resolve => {
      const facets = [];
      facets.push(`facet=${mainFilterItem?.apiKey || mainFilterItem?.key}`);

      // Get the parameters based on dependency key and group
      let additionalParams = '';
      const addParams = new Map();
      const mainFilterItems =
        isSummary && reportConfig
          ? reportConfig.mainFilterItems
          : currentConfig.mainFilterItems;
      if (
        mainFilterItem.dependencies &&
        mainFilterItem.dependencies.length > 0
      ) {
        mainFilterItem.dependencies.forEach(dependency => {
          if (!dependency.group || dependency.group === selectedGroup) {
            mainFilterItems
              .filter(
                item =>
                  ((dependency.key && item.key === dependency.key) ||
                    (dependency.label && item.label === dependency.label)) &&
                  (!item.groups ||
                    (item.groups.length > 0 &&
                      item.groups.indexOf(selectedGroup) >= 0)) &&
                  item.selected
              )
              .forEach(item => {
                let value = item.selected.value;
                if (route && route.snapshot.params[item.routeParam]) {
                  value = route.snapshot.params[item.routeParam];
                }
                // Facet requests take the same API values as the report
                // request. The route and the filters carry the device slug,
                // and the route may still carry a legacy one. MR-2633
                const option = item.options?.find(
                  dependencyOption =>
                    dependencyOption.value === value ||
                    (toDeviceSlug(value) &&
                      dependencyOption.value === toDeviceSlug(value))
                );
                addParams.set(
                  item?.apiKey || item?.key,
                  option?.apiValue || value
                );
              });
          }
        });
      }

      const reportId =
        isSummary && reportConfig
          ? reportConfig.reportId
          : currentConfig.reportId;

      // Prevent loading of historical data
      // Always load latest quarter/month
      const monthFilterItem = mainFilterItems.filter(
        filter => filter.key === 'date'
      )[0];
      if (addParams.get('date') && monthFilterItem) {
        addParams.set('date', monthFilterItem.options[0].value);
      }

      let selectedRegion = this.getRouteParamOrFilterValue(
        route,
        mainFilterItems,
        'Region'
      );
      const selectedCountry = this.getRouteParamOrFilterValue(
        route,
        mainFilterItems,
        'Country'
      );

      if (reportId === 'sellerTrustIndex') {
        if (addParams.get('date') >= '20240601') {
          if (mainFilterItem.label === 'Region') {
          } else if (mainFilterItem.label === 'Country') {
            if (['NA', 'EMEA', 'LATAM', 'APAC'].indexOf(selectedRegion) == -1) {
              selectedRegion = 'NA';
            }
            addParams.delete('countryCode');
            addParams.set('isRegion', false);
          }
        } else {
          if (mainFilterItem.label === 'Region') {
            addParams.delete('countryCode');
          } else if (mainFilterItem.label === 'Country') {
            mainFilterItem.options = [{ label: 'GLOBAL', value: 'GLOBAL' }];
            mainFilterItem.hidden = true;
            return resolve(true);
          }
        }
      } else {
        if (addParams.get('date') < '20210801') {
          if (reportId === 'publisherTrustIndex') {
            if (mainFilterItem.label === 'Country') {
              // No need to call the API
              mainFilterItem.options = [{ label: 'GLOBAL', value: 'GLOBAL' }];
              mainFilterItem.hidden = true;
              return resolve(true);
            }
            if (mainFilterItem.label === 'Category') {
              addParams.set('countryCode', selectedRegion);
            }
          } else {
            if (mainFilterItem.label === 'Region') {
              // No need to call the API
              mainFilterItem.options = [{ label: 'GLOBAL', value: 'GLOBAL' }];
              mainFilterItem.hidden = true;
              return resolve(true);
            }
            if (mainFilterItem.label === 'Category') {
              addParams.set('countryCode', selectedCountry);
            }
          }
        } else {
          if (mainFilterItem.label === 'Region') {
            addParams.set('isRegion', true);
          } else if (mainFilterItem.label === 'Country') {
            if (selectedRegion !== undefined) {
              addParams.delete('countryCode');
              addParams.set('isRegion', false);
              if (
                reportId === 'publisherTrustIndex' &&
                selectedGroup == 'domain'
              ) {
                addParams.set('parentRegion', selectedRegion);
              } else {
                addParams.set('region', selectedRegion);
              }
            }
          } else if (mainFilterItem.label === 'Category') {
            if (selectedCountry !== undefined && selectedCountry !== 'GLOBAL') {
              addParams.set('countryCode', selectedCountry);
              addParams.set('isRegion', false);
            } else if (selectedRegion !== undefined) {
              addParams.set('countryCode', selectedRegion);
              addParams.set('isRegion', true);
            }
          }
        }
      }

      if (addParams.size > 0) {
        additionalParams = this.mapToUrlParam(addParams);
      }
      void this.getRankingsFacets(
        facets,
        reportId,
        selectedGroup,
        additionalParams
      ).then(response => {
        const newOptions = [];
        const facetKey = mainFilterItem?.apiKey || mainFilterItem?.key;
        if (response && response['facets'] && response['facets'][facetKey]) {
          const facetOptions = response['facets'][facetKey];
          if (facetOptions && facetOptions.length > 0) {
            facetOptions.forEach(facetOption => {
              const option: any = {};
              const keys = Object.keys(facetOption);
              option.value = keys[0];
              option.label = keys[0];

              if (facetOption.name) {
                option.label = facetOption.name;
                option.name = facetOption.name;
              } else {
                option.label = option.value;
                option.name = option.value;
              }

              if (
                mainFilterItem.label === 'Country' &&
                option.value !== 'NON-US' &&
                option.value !== 'GLOBAL'
              ) {
                if (
                  reportId === 'sellerTrustIndex' &&
                  selectedGroup == 'domain' &&
                  addParams.get('date') < '20240601'
                ) {
                  if (option.value === 'NA') {
                    option.label = 'North America';
                  }
                } else {
                  if (facetOption.name) {
                    option.label = `<img alt="${option.label}" class="mr-1" width="18" src="https://cdn.pixalate.com/icons/countries/flat/48/${option.value}.png" onerror="this.src='/assets/icons/icon-72x72-grey.png';" /> ${option.label}`;
                  } else {
                    option.label = this.capitalizePipe.capitalize(option.label);
                  }
                }

                option.name = facetOption.name
                  ? facetOption.name
                  : option.value;
              } else if (
                mainFilterItem.label === 'Region' &&
                option.value === 'NA'
              ) {
                option.label = 'North America';
              } else if (mainFilterItem.label === 'Month') {
                option.label = this.getMonthOptionLabel(reportId, keys[0]);
                option.disabled = true;
              }

              // Show all options except GLOBAL for CTV and Apps STI
              // But show GLOBAL option for Domain STI and date later than Q3 2023`
              if (
                option.value !== 'GLOBAL' ||
                (reportId === 'sellerTrustIndex' &&
                  selectedGroup == 'domain' &&
                  addParams.get('date') > '20230901')
              ) {
                newOptions.push(option);
              }
            });
          }
        }
        // Sort Date Properly
        if (mainFilterItem.key === 'date') {
          mainFilterItem.options = newOptions.sort((option1, option2) =>
            option2.value.localeCompare(option1.value)
          );
          mainFilterItem.options[0].disabled = false;
          mainFilterItem.selected = mainFilterItem.options[0];
        } else if (mainFilterItem.key === 'category') {
          mainFilterItem.options = [];
          mainFilterItem.options.push({
            label: 'All Categories',
            value: 'GLOBAL'
          });
          mainFilterItem.options = mainFilterItem.options.concat(
            newOptions.sort((option1, option2) =>
              option1.label.localeCompare(option2.label)
            )
          );
        } else if (
          mainFilterItem.key === 'countryCode' ||
          mainFilterItem.key === 'region'
        ) {
          mainFilterItem.options = [];
          if (mainFilterItem.label === 'Region') {
            mainFilterItem.hidden = false;
            if (
              (reportId === 'publisherTrustIndex' ||
                reportId === 'sellerMarketShare' ||
                (reportId === 'sellerTrustIndex' &&
                  addParams.get('date') >= '20240601')) &&
              newOptions.length === 0
            ) {
              mainFilterItem.options.push({
                label: 'North America',
                value: 'NA'
              });
            }
          } else if (mainFilterItem.label === 'Country') {
            mainFilterItem.hidden = false;
            if (reportId === 'publisherTrustIndex' && newOptions.length === 0) {
              mainFilterItem.hidden = true;
            }
            if (reportId !== 'sellerTrustIndex') {
              mainFilterItem.options.push({
                label: 'All Countries',
                value: 'GLOBAL'
              });
            }
          }
          mainFilterItem.options = mainFilterItem.options.concat(
            newOptions.sort((option1, option2) => {
              return option1.name.localeCompare(option2.name, 'en', {
                sensitivity: 'base'
              });
            })
          );
        } else {
          mainFilterItem.options = [mainFilterItem.default];
          mainFilterItem.options = mainFilterItem.options.concat(
            newOptions.sort((option1, option2) =>
              option1.label.localeCompare(option2.label)
            )
          );
        }

        // const isAnonymous = this.userServce.isAnonymous();

        // if (isAnonymous) {
        //   const enabledOption =
        //     mainFilterItem.default || mainFilterItem.options[0];
        //   mainFilterItem.options.forEach(option => {
        //     if (option.value != enabledOption.value) {
        //       option.disabled = true;
        //     }
        //   });
        // }

        const defaultValue = this.getDefaultValue(
          reportId,
          mainFilterItem.label,
          selectedGroup,
          selectedRegion,
          addParams
        );
        this.setFilterItemSelected(mainFilterItem, defaultValue);
        resolve(true);
      });
    });
  }

  getDefaultValue(
    reportId: string,
    label: string,
    selectedGroup: string,
    selectedRegion: string,
    addParams: Map<string, string>
  ) {
    if (reportId === 'sellerTrustIndex') {
      if (selectedGroup == 'domain') {
        if (label == 'Region') {
          if (addParams.get('date') <= '20230901') {
            return 'US';
          }
          if (addParams.get('date') < '20240601') {
            return 'GLOBAL';
          }
          return 'NA';
        }
        if (label == 'Country') {
          return DEFAULT_COUNTRY_PER_REGION_MAPPING[selectedRegion];
        }
      }
      if (selectedGroup == 'app') {
        if (label == 'Region') {
          if (addParams.get('date') < '20240601') {
            return 'GLOBAL';
          }
          return 'NA';
        }
        if (label == 'Country') {
          if (addParams.get('date') < '20240601') {
            return 'GLOBAL';
          }
          return DEFAULT_COUNTRY_PER_REGION_MAPPING[selectedRegion];
        }
      }
      if (selectedGroup == 'ctv') {
        if (label == 'Region') {
          if (addParams.get('date') <= '20230901') {
            return 'US';
          }
          if (addParams.get('date') < '20240601') {
            return 'GLOBAL';
          }
          return 'NA';
        }
        if (label == 'Country') {
          return DEFAULT_COUNTRY_PER_REGION_MAPPING[selectedRegion];
        }
      }
    }
  }
}
